import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import DashboardInfoLabel from '../utils/DashboardInfoLabel';

function DashboardGarphCardLayout({ title, children, tooltip, impNote, redirection }) {
  const filterData = useSelector((state) => state.filters.dashboardMultiSelectFilters);
  const parentChildStatus = useSelector((state) => state.filters.dashboardParentChildStatus);
  return (
    <div className="dashboard-graph-card-layout">
      {title && title !== 'Billed vs Paid' && (
        <DashboardInfoLabel
          id={uniqueId('graph-tooltip')}
          label={title}
          showIcon
          toolTipText={tooltip}
          className="dashboard-graph-card-title"
        />
      )}
      <div className="graph-card-body">
        {children}
        {impNote && children && <p className="imp-note">*{impNote}</p>}
      </div>
      {redirection?.enabled ? (
        <p className="card-redirection-label">
          <span>{`Get overall ${title} report`}</span>
          <button
            type="button"
            className="redirection-btn"
            onClick={() => {
              redirection.redirect({
                pathname: redirection?.path,
                filterType: redirection?.filterType,
                reportDate: '',
                startDate: '',
                endDate: '',
                duration: null,
                value: redirection?.values,
                redirectionFrom: 'dashboard',
                globalFilters: filterData,
                parentChildStatus,
              });
            }}
          >
            here
          </button>
        </p>
      ) : null}
    </div>
  );
}

DashboardGarphCardLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.string.isRequired,
  impNote: PropTypes.string.isRequired,
  redirection: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    to: PropTypes.string.isRequired,
    redirect: PropTypes.func.isRequired,
  }).isRequired,
};

export default DashboardGarphCardLayout;
